import { Interval } from 'luxon';

import { AvailabilityInterval, ReservableAvailabilityReason } from './types';

type UserBlockedInterval = {
  interval: Interval;
  eventType: string | null;
};

export function mergeUserCapReachedIntervals(
  globalIntervals: AvailabilityInterval[],
  userBlockedIntervals: UserBlockedInterval[],
  maxQuantityPerSlot: number
): AvailabilityInterval[] {
  const merged: AvailabilityInterval[] = globalIntervals.map(g => ({ ...g }));

  for (const blocked of userBlockedIntervals) {
    const startMs = blocked.interval.start.valueOf();
    const endMs = blocked.interval.end.valueOf();
    const match = merged.find(
      g => g.startDate.getTime() === startMs && g.endDate.getTime() === endMs
    );

    if (match) {
      if (match.reason !== ReservableAvailabilityReason.Full) {
        match.reason = ReservableAvailabilityReason.UserCapReached;
      }

      continue;
    }

    merged.push({
      startDate: blocked.interval.start.toJSDate(),
      endDate: blocked.interval.end.toJSDate(),
      eventType: blocked.eventType,
      remainingSpots: maxQuantityPerSlot,
      reason: ReservableAvailabilityReason.UserCapReached,
    });
  }

  return merged.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
}
